/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './enableJoinLink.defs.js'
export { main as default } from './enableJoinLink.defs.js'
